export const toPieChartData = (data, contractTypes) => {
  if (!data) return {}

  let totalWonValue = 0
  let totalBidValue = 0
  let totalCount = 0
  let wonCount = 0
  const piesObj = {
    pieByBidValue: [],
    pieByWonValue: []
  }

  const pies = Object.keys(data).reduce((a, item) => {
    const elem = data[item]
    totalBidValue += elem.totalBidValue
    totalWonValue += elem.totalWonValue
    totalCount += elem.count
    wonCount += elem.wonCount

    const contractType = contractTypes.find(c => +c.value === +elem.deals[0].dealWorkTypeId)

    piesObj.pieByBidValue.push({
      id: contractType ? contractType.label : 'Empty',
      label: contractType ? contractType.label : 'Empty',
      value: elem.totalBidValue
    })

    piesObj.pieByWonValue.push({
      id: contractType ? contractType.label : 'Empty',
      label: contractType ? contractType.label : 'Empty',
      value: elem.totalWonValue
    })

    return piesObj
  }, [])

  return {
    pies,
    totalWonValue,
    totalBidValue,
    totalCount,
    wonCount
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toCategories = categories =>
  categories.map(category => ({
    value: category.id,
    label: category.name,
    system: category.system,
    code: category.code
  }))
